// External Dependencies:
import React from 'react'

class File extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			hasError: false,
			files: []
		}
	}

	static defaultProps = {
		handleError: false
	}

	handleChange = ( e ) => {
		const { id, multiple } = this.props
		const files = Array.from( e.target.files )
		let newFiles

		if ( multiple ) {
			newFiles = [
				...this.state.files,
				...files
			]
		} else {
			newFiles = files
		}

		this.setState( {
			files: newFiles
		} )

		this.props.onChange( id, newFiles )
	}

	removeFile = ( e ) => {
		const name = e.currentTarget.getAttribute( 'data-name' )

		this.setState( {
			files: this.state.files.filter( file => file.name !== name )
		} )
	}

	renderFilesList = () => {
		const { files } = this.state
		let markup

		markup = files.map( file => {
			return (
				<div className="-file" key={ file.name }>
					<div className="-name">{ file.name }</div>

					<i className="icon-close" onClick={ this.removeFile } data-name={ file.name }></i>
				</div>
			)
		} )

		return (
			<div className="-files">{ markup }</div>
		)
	}

	render() {
		let { id, label, buttonLabel, value, multiple, style } = this.props
		const { hasError } = this.state
		let className = hasError ? 'form-item form-file has-error' : 'form-item form-file'
		const hasMultiple = multiple ? true : null

		if ( ! multiple && value.length ) {
			buttonLabel = value[0].name
		}

		if ( ! style ) {
			style = null
		}

		return (
			<div className={ className } style={ style }>
				<label dangerouslySetInnerHTML={ { __html: label } } />

				<input type="file" id={ id } name={ id } onChange={ this.handleChange } multiple={ hasMultiple } />

				<label className="-file-button" htmlFor={ id } dangerouslySetInnerHTML={ { __html: buttonLabel } } />

				{ multiple && this.renderFilesList() }
			</div>
		)
	}
}

export default File
